import EmissionPlan from './EmissionPlan';

export default EmissionPlan;
